export default "__VITE_ASSET__kL2UujxZ__"